import React, { useEffect, useState } from 'react'
import { CTA as CTAType } from 'types/campaign/collaborations'
import CTA from './CTA'

const CampaignCTAs: React.FC<{ cta_list: CTAType[], onChange: (ctaList: CTAType[]) => void, viewOnly?: boolean }> = ({ cta_list, onChange, viewOnly = false }) => {
    const [ctaList, setCTAList] = useState<CTAType[]>(cta_list)

    useEffect(() => {
        if (cta_list.length === 1 && Array.isArray(cta_list[0])) {
            onChange([]);
            setCTAList([]);
        } else {
            setCTAList(cta_list);
        }
    }, [cta_list])

    const getSanitizedCTAs = (ctas: CTAType[]) => {
        return ctas.filter((c) => c.text).map((c) => ({ text: c.text, url: c.url }))
    }

    return (
        <>
            {
                ctaList.length > 0 ? (
                    <>
                        {

                            ctaList.map((cta, index) => (
                                <CTA key={index} cta={cta}
                                    viewOnly={viewOnly}
                                    onChange={(updatedQuestion) => {
                                        const updatedCTAs = [...ctaList];
                                        updatedCTAs[index] = updatedQuestion;
                                        setCTAList(updatedCTAs);
                                    }}
                                    onSave={() => {
                                        onChange(getSanitizedCTAs(ctaList))
                                    }}
                                    onDelete={() => {
                                        const updatedCTAs = [...ctaList];
                                        updatedCTAs.splice(index, 1);
                                        setCTAList(updatedCTAs);
                                        onChange(getSanitizedCTAs(updatedCTAs));
                                    }} />
                            ))
                        }

                    </>
                ) : (
                    <p className='mt-2 mb-0'>No CTAs added.</p>
                )
            }
            {
                !viewOnly &&
                <button type="button" className="btn btn-link p-0 mt-3" onClick={() => {
                    const updatedCTAs = [...ctaList];
                    updatedCTAs.push({ text: '', url: '', unsaved: true });
                    setCTAList(updatedCTAs);
                }}>+ Add CTA</button>
            }

        </>
    )
}

export default CampaignCTAs
